import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import icon from './images/Akaay infra Main logo.png';
import logo from './images/Akaay infra logo.png';
import Body from './components/Body';
import backtower from './images/backtower.jpg.jpeg';

function App() {
  const [showIcon, setShowIcon] = useState(true);
  const [showFrame, setShowFrame] = useState(false);
  const containerRef = useRef(null);
  const [time] = useState(new Date());
  const [frames, setFrames] = useState([]);

  const handleShowFrame = () => {
    setShowFrame(true);
    setShowIcon(false);
  };

  const handleHideFrame = () => {
    setShowFrame(false);
    setShowIcon(true);
  };

  const addFrame = (frameComponent) => {
    setFrames((prevFrames) => [...prevFrames, frameComponent]);
  };

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [frames]);

  return (
    <div
      className="App"
      style={{
        fontFamily: 'Poppins, sans-serif',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#f8f9fa',
        position: 'relative',
      }}
    >
     {/* Header */}
<header
  style={{
    backgroundImage: `url(${backtower})`, // Use your actual image path here
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: '#fff',
    textAlign: 'center',
    padding: '5rem 1rem',
    minHeight: '60vh',
    position: 'relative',
  }}
>
  {/* Optional overlay */}
  <div
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)', // dark overlay for better text contrast
      zIndex: 1,
    }}
  ></div>

  {/* Header text */}
  <div style={{ position: 'relative', zIndex: 2 }}>
    <h1 style={{ fontSize: '3.5rem', fontWeight: 'bold' }}>Akaay Infra</h1>
    <p style={{ fontSize: '1.5rem' }}>Your dream infra solutions, redefined!</p>
  </div>
</header>

      {/* Main Content */}
      <main
        className="container"
        style={{
          flex: '1',
          padding: '2rem',
          textAlign: 'center',
        }}
      >
        <h2 style={{ marginBottom: '1rem', fontWeight: '600' }}>Our Services</h2>
        <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '0 auto' }}>
          From smart city planning to luxurious commercial spaces, Akaay Infra is
          building the future of India.
        </p>
      </main>

      {/* Footer */}
      <footer
        style={{
          backgroundColor: '#f1f1f1',
          textAlign: 'center',
          padding: '1.5rem 1rem',
          marginTop: 'auto',
        }}
      >
        <p style={{ margin: 0, fontWeight: '500' }}>
          © 2025 <strong>Akaay Infra</strong>. All rights reserved.
        </p>
      </footer>

      {/* Floating Chatbot Icon */}
      {showIcon && (
        <button
          className="icon"
          onClick={handleShowFrame}
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            border: 'none',
            background: 'transparent',
            zIndex: 1000,
            cursor: 'pointer',
          }}
        >
          <img src={icon} alt="Chat Icon" className="icon-img" style={{ width: '70px', height: '70px' }} />
        </button>
      )}

      {/* Chat Frame */}
      {showFrame && (
        <div className="background-frame">
          <div className="head">
            <img src={logo} alt="Akaay Logo" className="logo" />
            <div>
              <div className="head-text">Akaay Infra</div>
              <p className="head-qoute">We are online to assist you</p>
            </div>
            <button className="close-icon" onClick={handleHideFrame}>
  &#10006;
</button>
          </div>
          <div className="time">Today {time.toLocaleTimeString()}</div>
          <div className="body" ref={containerRef}>
            <Body />
            {frames.map((frame, index) => (
              <div key={index}>{frame}</div>
            ))}
          </div>
          <div className="footer">
            Powered by <b>AKAAY AI</b>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;

